import { useMemo } from "react";
import { TransactionReviewField } from "@common/types/transactionFieldReview";
import { useAnyEntityHasAccrualLedger } from "@api/ledger.api";
import { useBusinessNonMockEntityIds } from "./useBusinessEntityIds";
import { useIsGlFirst } from "./useIsGlFirst";

interface ReviewableFieldFlags {
    isGlFirst: boolean;
    hasAccrualLedger: boolean;
}

export function getReviewableFields({
    isGlFirst,
    hasAccrualLedger,
}: ReviewableFieldFlags): TransactionReviewField[] {
    return Object.values(TransactionReviewField).filter((field) => {
        switch (field) {
            case TransactionReviewField.CATEGORY:
                return !isGlFirst;
            case TransactionReviewField.ACCRUAL_LEDGER:
                return hasAccrualLedger;
            default:
                return true;
        }
    });
}

export function withSelectedReviewFields({
    reviewableFields,
    selectedFields,
}: {
    reviewableFields: TransactionReviewField[];
    selectedFields: TransactionReviewField[];
}): TransactionReviewField[] {
    return Object.values(TransactionReviewField).filter(
        (field) =>
            reviewableFields.includes(field) || selectedFields.includes(field),
    );
}

export function useReviewableFields(): TransactionReviewField[] {
    const { enabled: isGlFirst } = useIsGlFirst();
    const entityIds = useBusinessNonMockEntityIds();
    const hasAccrualLedger = useAnyEntityHasAccrualLedger(entityIds);
    return useMemo(
        () => getReviewableFields({ isGlFirst, hasAccrualLedger }),
        [isGlFirst, hasAccrualLedger],
    );
}
